import { combineReducers } from 'redux';
import {
  reducer as authReducer,
  STATE_KEY as AUTH_STATE_KEY,
} from './modules/auth';

import {
  reducer as dataReducer,
  STATE_KEY as DATA_STATE_KEY,
} from './modules/data';

import {
  reducer as driveReducer,
  STATE_KEY as DRIVE_STATE_KEY,
} from './modules/drive';

export default combineReducers({
  [AUTH_STATE_KEY]: authReducer,
  [DATA_STATE_KEY]: dataReducer,
  [DRIVE_STATE_KEY]: driveReducer,
});
